import { Component, Children, cloneElement, createRef } from 'react';
import PropTypes from 'prop-types';

export class OutsideClick extends Component {
  static propTypes = {
    addOutsideClickListener: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    onOutsideClick: PropTypes.func.isRequired,
  };

  childElementRef = createRef();

  handleOutsideClick = event => {
    const { onOutsideClick } = this.props;

    if (this.childElementRef.current.contains(event.target)) {
      return;
    }

    onOutsideClick();
  };

  componentDidUpdate() {
    const { addOutsideClickListener } = this.props;
    addOutsideClickListener
      ? document.addEventListener('mousedown', this.handleOutsideClick)
      : document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  render() {
    const { children } = this.props;
    const childElement = Children.only(children);

    return cloneElement(childElement, { ref: this.childElementRef });
  }
}
